import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const initialReferralState = {
data:{},
flow:""
};

export const referralSlice = createSlice({
  name: "referral",
  initialState: initialReferralState,
  reducers: {
    setReferral: (state, action) => {
      return {
        data: action.payload?.data,
        flow:action.payload?.flow

      };
    },

  },
});

export const { setReferral} =
  referralSlice.actions;
